import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Este componente não renderiza nada; ele apenas reposiciona a janela no topo
// sempre que a rota muda.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
